import { render, staticRenderFns } from "./explainer-account-confirmation-form.vue?vue&type=template&id=16234f7e&scoped=true&"
import script from "./explainer-account-confirmation-form.vue?vue&type=script&lang=js&"
export * from "./explainer-account-confirmation-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16234f7e",
  null
  
)

export default component.exports